import { render, staticRenderFns } from "./detallePedidoAdmin.vue?vue&type=template&id=f9350b0e&scoped=true&"
import script from "./detallePedidoAdmin.vue?vue&type=script&lang=js&"
export * from "./detallePedidoAdmin.vue?vue&type=script&lang=js&"
import style0 from "./detallePedidoAdmin.vue?vue&type=style&index=0&id=f9350b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9350b0e",
  null
  
)

export default component.exports